import Cookies from 'js-cookie'

const TokenKey = 'zhihui-manage-app'

export function getApp() {
  let app = Cookies.get(TokenKey)
  if(app)return JSON.parse(app)
  return {}
}

export function setApp(token) {
  return Cookies.set(TokenKey, JSON.stringify(token))
}

export function removeApp() {
  return Cookies.remove(TokenKey)
}
export function getListOptions(name, list){
  let ret = []
  if(name == '小学') {
    let arr = ['语文','数学','英语','道德与法治','其他']
    for(var i in list){
      var item = list[i]
      if(arr.indexOf(item.name)>=0) ret.push(item)
    }
  }else if(name == '初中') {
    let arr = ['语文','数学','英语','物理','化学','生物','地理','历史','道德与法治','其他']
    for(var i in list){
      var item = list[i]
      if(arr.indexOf(item.name)>=0) ret.push(item)
    }
  }else if(name == '高中') {
    let arr = ['语文','数学','英语','物理','化学','生物','地理','历史','思想政治','其他']
    for(var i in list){
      var item = list[i]
      if(arr.indexOf(item.name)>=0) ret.push(item)
    }
  }
  return ret
}